import {
    UPDATE_UTILISATEUR_REQUEST,
    UPDATE_UTILISATEUR_SUCCESS,
    UPDATE_UTILISATEUR_FAILURE,
  } from "../Types";
  
  const initialState = {
    loading: false,
    error: null,
    utilisateurMisAJour: null, 
  };
  
  const UpdateUtilisateursReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_UTILISATEUR_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case UPDATE_UTILISATEUR_SUCCESS:
        return {
          ...state,
          loading: false,
          utilisateurMisAJour: action.payload,
        };
  
      case UPDATE_UTILISATEUR_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default UpdateUtilisateursReducer;
  